// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const REGISTER_REQUEST = 'REGISTER_REQUEST';
const REGISTER_RESPONSE = 'REGISTER_RESPONSE';
const REGISTER_FAILED = 'REGISTER_FAILED';

const REGISTER_REQUEST_SUCCESS = 'REGISTER_REQUEST_SUCCESS';
const REGISTER_REQUEST_FAILED = 'REGISTER_REQUEST_FAILED';

const REGISTER_FIELD_CHANGE = 'REGISTER_FIELD_CHANGE';
const REGISTER_ERRORS_CHANGE = 'REGISTER_ERRORS_CHANGE';
const REGISTER_ADDRESS_FIELD_CHANGE = 'REGISTER_ADDRESS_FIELD_CHANGE';
const REGISTER_BANK_FIELD_CHANGE = 'REGISTER_BANK_FIELD_CHANGE';

const REGISTER_FORM_RESET = 'REGISTER_FORM_RESET';
const REGISTER_SELECTED_ADDRESS_REQUEST = 'REGISTER_SELECTED_ADDRESS_REQUEST';
const REGISTER_SELECTED_ADDRESS_REQUEST_FAILED = 'REGISTER_SELECTED_ADDRESS_REQUEST_FAILED';

const PHONE_NUMBER_VALIDATION_FAILED = 'PHONE_NUMBER_VALIDATION_FAILED';

export {
  REGISTER_REQUEST,
  REGISTER_RESPONSE,
  REGISTER_FAILED,

  REGISTER_REQUEST_SUCCESS,
  REGISTER_REQUEST_FAILED,

  REGISTER_FIELD_CHANGE,
  REGISTER_ERRORS_CHANGE,
  REGISTER_ADDRESS_FIELD_CHANGE,
  REGISTER_BANK_FIELD_CHANGE,

  REGISTER_FORM_RESET,
  REGISTER_SELECTED_ADDRESS_REQUEST,
  REGISTER_SELECTED_ADDRESS_REQUEST_FAILED,

  PHONE_NUMBER_VALIDATION_FAILED,
};
